import { z } from 'zod';

/**
 * B-A.2.1 — ToolCode: типизированный идентификатор инструмента в gateway / audit / approval matrix.
 * Каждый код — operation над ресурсом. Frontend рендерит label через `m.tool_{code}_label()`.
 */
export const ToolCode = z.enum([
  // Items
  'item.create',
  'item.update',
  'item.delete',
  'item.valuation_method.change',
  'item.variant.upsert',
  'item_group.create',
  'item_group.delete',
  // Warehouses
  'warehouse.create',
  'warehouse.update',
  'warehouse.delete',
  // Batches
  'batch.create',
  'batch.update',
  'batch.qc_approve',
  'batch.qc_reject',
  'batch.quarantine',
  // BOMs
  'bom.create',
  'bom.update',
  'bom.activate',
  'bom.deactivate',
  'bom.explode',
  'bom_item.upsert',
  'bom_item.delete',
  'bom_operation.upsert',
  'bom_operation.delete',
  // Stock
  'stock_entry.create',
  'stock_entry.submit',
  'stock_entry.cancel',
  'stock_reconciliation.create',
  'stock_reconciliation.submit',
  'landed_cost.create',
  'landed_cost.submit',
  'landed_cost.cancel',
  // Work Orders
  'work_order.create',
  'work_order.release',
  'work_order.start',
  'work_order.complete',
  'work_order.cancel',
  'job_card.create',
  'job_card.update',
  // Agent / runs
  'run.start',
  'run.stop',
  'run.approve',
  'run.reject',
  // Admin / User
  'user.create',
  'user.update',
  'user.deactivate',
  'user.locale_change',
  'integration.create',
  'integration.update',
  'integration.sync_trigger',
  'approval_matrix.create',
  'approval_matrix.update',
  'approval_matrix.delete',
  // Regulatory (Tier 3)
  'regulatory.esf.generate',
  'regulatory.esf.push_1c',
  'regulatory.esf.submit_tax',
  'regulatory.kpn.generate',
  'regulatory.kpn.push_1c',
]);
export type ToolCode = z.infer<typeof ToolCode>;
